module.exports = __webpack_public_path__ + "img/455.0ce149a0.png";